export enum SectionName {
  StaffList = 'staffListWidget',
  Timetable = 'timetableWidget',
  BookingsHealthWaivers = 'bookingsHealthWaivers',
  ChatButton = 'chatButtonSection',
  LiveChat = 'liveChatSection',
  StripContainerContact = 'stripContainerContactSection',
  PopupSubscribe = 'popupSubscribeSection',
  PopupSale = 'popupSaleSection',
  PopupContact = 'popupContactSection',
  MultiStep = 'multiStepSection',
  Donations = 'donationsSection',
  Payment = 'paymentSection',
  Contact = 'contactSection',
  Contests = 'contestsSection',
  Testimonial = 'testimonialSection',
  Support = 'supportSection',
  Subscribers = 'subscribersSection',
  SalesLead = 'salesLeadSection',
  Quiz = 'quizSection',
  PriceQuotes = 'priceQuotesSection',
  JobApplication = 'jobApplicationSection',
  HealthDeclaration = 'healthDeclarationSection',
  Feedback = 'feedbackSection',
  Featured = 'featuredSection',
  CampaignFeatured = 'campaign_featuredSection',
  LanguageSelector = 'languageSelectorSection',
  StylableHorizontalMenu = 'stylableHorizontalMenuSection',
  StylableMenuTheme = 'stylableMenuTheme',
  HorizontalMenus = 'horizontalMenusSection',
  Breadcrumbs = 'breadcrumbsSection',
  SiteSearch = 'siteSearchSection',
  YoutubeSocial = 'youtubeSocialSection',
  Pinterest = 'pinterestSection',
  Facebook = 'facebookSection',
  Twitter = 'twitterSection',
  VK = 'vkSection',
  SpotifySocial = 'spotifySocialSection',
  SpotifyPlayer = 'spotifyPlayerSection',
  SoundCloud = 'soundCloudSection',
  MarketingIntegrations = 'marketingIntegrationsSection',
  VeloDevMode = 'veloDevModeSection',
  SignatureInput = 'signatureInputSection',
  Captcha = 'captchaSection',
  CollectionsSection = 'collectionsSection',
  DataBindingSection = 'dataBindingSection',
  ContentManagerWelcome = 'databaseWelcomeSection',
  Preset = 'presetSection',
  MusicThemeSection = 'musicThemeSection',
  AddPages = 'addPagesSection',
  ArchiveSection = 'archiveSection',
  CategoryMenuSection = 'categoryMenuSection',
  CustomFeedSection = 'customFeedSection',
  PostListEditorialSmallSection = 'postListEditorailSmallSection',
  PostListListSmallSection = 'postListListSmallSection',
  PostListSliderSmallSection = 'postListSliderSmallSection',
  RecentPostsSection = 'recentPostsSection',
  RssButtonSection = 'rssButtonSection',
  TagCloudSection = 'tagCloudSection',
  BlogWelcome = 'blogWelcomeSection',
  AddToCartButton = 'addToCartButton',
  CurrencyConverter = 'currencyConverter',
  MultipleProductWidgets = 'multipleProductWidgets',
  ProductGridWidget = 'productGridWidget',
  ShoppingBagWidget = 'shoppingBagWidget',
  SliderProductGalleryWidget = 'sliderProductGalleryWidget',
  HoverBox = 'hoverBoxSection',
  InteractionsHover = 'interactionsHoverSection',
  StateBox = 'stateBoxSection',
  VideoBoxMasked = 'videoBoxMaskedSection',
  LeanGalleries = 'leanGalleriesSection',
  ProGalleries = 'proGalleriesSection',
  WixVideo = 'wixVideoSection',
  WixMusic = 'wixMusicSection',
  VideoBox = 'videoBoxSection',
  StripBoxSlideShow = 'stripBoxSlideShowSection',
  StripContainerAbout = 'stripContainerAboutSection',
  StripContainerClassic = 'stripContainerClassicSection',
  StripContainerServices = 'stripContainerServicesSection',
  StripContainerTestimonials = 'stripContainerTestimonialsSection',
  StripContainerWelcome = 'stripContainerWelcomeSection',
  StripContainerTeam = 'stripContainerTeamSection',
  ProgressBar = 'progressBarSection',
  Pagination = 'paginationSection',
  PopupWelcome = 'popupWelcomeSection',
  VideoBoxTransparent = 'videoBoxTransparentSection',
  Paragraphs = 'paragraphsSection',
  Titles = 'titlesSection',
  Anchors = 'anchorsSection',
  VerticalAnchorsMenu = 'verticalAnchorsMenuSection',
  VerticalMenus = 'verticalMenusSection',
  CustomEmbeds = 'customEmbedsSection',
  RelatedApps = 'relatedAppsSection',
  RelatedProductGalleryWidget = 'relatedProductGalleryWidget',
  FileUploader = 'fileUploaderSection',
  StylableButton = 'stylableButtonSection',
  StylableButtonTheme = 'stylableButtonTheme',
  TextButtons = 'textButtonsSection',
  Section1 = 'section_1',
  Section2 = 'section_2',
  RecentPostsListSection = 'recentPostsListSection',
  PostListSidebarSection = 'postListSidebarSection',
  PostListLargeSection = 'postListLargeSection',
}

export const CustomSectionName = {
  MyDesigns: 'CUSTOM_SECTION_MY_DESIGNS',
  MyWidgets: 'CUSTOM_SECTION_MY_WIDGETS',
  MobileTools: 'CUSTOM_SECTION_MOBILE_TOOLS',
  ElementsRegistryDev: 'CUSTOM_SECTION_ELEMENTS_REGISTRY_DEV',
  BlankSection: 'CUSTOM_SECTION_BLANK_SECTION',
  SiteSearch: SectionName.SiteSearch,
  VeloDevMode: SectionName.VeloDevMode,
} as const;

export type CustomSectionNameType = typeof CustomSectionName[keyof typeof CustomSectionName];
